module.exports = __webpack_public_path__ + "img/cola.deba8268.png";